import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';
import { t } from 'i18next';
import { snakeCase } from 'lodash-es';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { FileAttachment } from '~hooks/useFileAttachment/models';

interface CategoryColumnProps {
  file: FileAttachment;
  sx?: SxProps<Theme>;
}

export default function CategoryColumn({ file, sx }: CategoryColumnProps) {
  const { category } = file;

  return (
    <Box sx={{ ...sx, overflow: 'hidden' }}>
      <OverflowAwareText>
        {t(`enums.file_attachment_category.${snakeCase(category)}`)}
      </OverflowAwareText>
    </Box>
  );
}
